import React from 'react';
import './projectCounter.scss';

const ProjectCounter = ({status, value}) => {

    return (
        <span className='projectCounterContainer'>
            <div className={status + 'Counter projectCounter'}>
                <p className={'numProjects '+status}>{value}</p>
            </div>

        </span>
    );  
}

export default ProjectCounter;